import clsx from "clsx";

import { DateTimeTz, Icon } from "@web-app/components";
import { OrderTimeline } from "@web-app/types";
import { OrderTimelineSchema, timeZoneMap } from "@web-app/utils/helpers";

export default function ConnectedWorkspaceActivity({
  item,
  showTimelineBar,
  timezone,
}: {
  item: OrderTimeline;
  showTimelineBar: boolean;
  timezone: keyof typeof timeZoneMap | undefined;
}) {
  // Don't render events created before October 14th, 2025
  // This is because this PR was merged which contains the proper connected workspace name
  // https://github.com/fulflld/web-api/pull/934
  const oct14th2025 = new Date("2025-10-14T00:00:00");
  const itemCreatedAt = new Date(item.createdAt);

  if (itemCreatedAt < oct14th2025) {
    return null;
  }

  return (
    <li key={item.id} className="relative flex gap-x-2 md:gap-x-4">
      <div
        className={clsx(
          showTimelineBar ? "-bottom-6" : "h-6",
          "absolute left-0 top-0 flex w-6 justify-center",
        )}
      >
        <div className="w-px bg-gray-200" />
      </div>
      <div className="relative flex h-7 w-6 flex-none items-center justify-center bg-white">
        <Icon name="fasGlobe" className="h-3 md:h-4" />
      </div>
      <p className="flex-auto flex flex-col items-start py-0.5 text-[10px] md:text-xs leading-0 md:leading-5 text-gray-500">
        <span className={"inline-block font-medium text-gray-900"}>
          {!item.updatedValue &&
            item.previousValue &&
            `${OrderTimelineSchema[item.entity].action.DELETE.text} ${
              item.previousValue
            } workspace`}
          {item.updatedValue &&
            `${OrderTimelineSchema[item.entity].action[item.action].text} ${
              item.updatedValue
            } workspace`}
        </span>
        <span className="relative">
          <DateTimeTz
            start={new Date(item?.createdAt)}
            timezone={timezone}
            createdBy={item?.createdBy?.name}
            presentation="timeline"
          />
        </span>
      </p>
    </li>
  );
}
